function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire2d52"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire2d52"] = parcelRequire;
}
parcelRequire.register("e26He", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $a376725c7b3db8f2$export$6503ec6e8aabbaf; }, function (v) { return $a376725c7b3db8f2$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $a376725c7b3db8f2$export$f7ad0328861e2f03; }, function (v) { return $a376725c7b3db8f2$export$f7ad0328861e2f03 = v; });
var $a376725c7b3db8f2$export$6503ec6e8aabbaf;
var $a376725c7b3db8f2$export$f7ad0328861e2f03;
"use strict";
var $a376725c7b3db8f2$var$mapping = {};
function $a376725c7b3db8f2$var$register(pairs) {
    var keys = Object.keys(pairs);
    for(var i = 0; i < keys.length; i++)$a376725c7b3db8f2$var$mapping[keys[i]] = pairs[keys[i]];
}
function $a376725c7b3db8f2$var$resolve(id) {
    var resolved = $a376725c7b3db8f2$var$mapping[id];
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return resolved;
}
$a376725c7b3db8f2$export$6503ec6e8aabbaf = $a376725c7b3db8f2$var$register;
$a376725c7b3db8f2$export$f7ad0328861e2f03 = $a376725c7b3db8f2$var$resolve;

});

var $ad9c68a11982b2fc$exports = {};

(parcelRequire("e26He")).register(JSON.parse('{"fCzRa":"index.d52266aa.js","l4XaK":"apple-touch-icon.176c0538.png","53ysa":"favicon.561cee98.png","4YVoE":"index.94c7bc3a.css"}'));


//# sourceMappingURL=index.4c4135b2.js.map
